import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import axiosOrganizationInstance from './AxiosOrganizationInstance';
import './css/school-list.css'
import './css/checkbox.css'

function OrganizationList() {
    const [organizationName,setorganizationName] = useState("");
    const [organizationCode, setorganizationCode] = useState("");
    const [admissions, setAdmissions] = useState("");
    const [specialization, setSpecialization] = useState("");
    const [offers, setOffers] = useState("");
    const [features, setFeatures] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [notes, setNotes] = useState("");
    const [status, setStatus] = useState("");
    const [contactName, setContactName] = useState("");
    const [createdById, setCreatedById] = useState("");
    const [password, setPassword] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [organizationId, setorganizationId] = useState(null);
    const navigate= useNavigate()

    // Token validation and redirection
    useEffect(() => {
        const checkToken = () => {
            const token = localStorage.getItem("Token");
            if (!token) {
                navigate("/organization/signin");
            }
        };

        checkToken();
        const intervalId = setInterval(checkToken, 200000); // Check token status every 5 minutes
        return () => clearInterval(intervalId);
    }, [navigate]);

    useEffect(() => {
        // Retrieve organizationId from localStorage
        const organizationId = localStorage.getItem("organizationId");
        console.log("Retrieved organizationId from localStorage:", organizationId);      
        if (!organizationId || organizationId === "null") {        
          setLoading(false);
          setorganizationId(null); // Explicitly set organizationId to null
          return; // Exit early and stop further execution (no API call)
        }
      
        // If organizationId is valid (not null, empty, or "null"), proceed with API call logic
        setorganizationId(organizationId);
        setLoading(true); // Start loading before making the API call
      
        // Function to fetch organization details
        const fetchorganization = async () => {
          // If organizationId is null (this should never be reached since we returned early above), stop and don't make the API call
          if (!organizationId || organizationId === "null") {
            console.log("Skipping fetch as organizationId is null.");
            setLoading(false); // Stop loading if no organizationId
            return; // Return early to prevent API call (this is a safety check)
          }
      
          try {
            const token = localStorage.getItem("Token");
            const response = await axiosOrganizationInstance.get(`/organization/${organizationId}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
      
            const organization = response.data;
            console.log("API Response:", organization); // Debugging
      
            if (organization) {
              // If organization data is found, set all organization details
              setorganizationCode(organization.organizationCode || "N/A");
              setorganizationName(organization.organizationName || "N/A");
              setAdmissions(organization.admissions || "N/A");
              setSpecialization(organization.specialization || "N/A");
              setOffers(organization.offers || "N/A");
              setFeatures(organization.features || "N/A");
              setPhoneNumber(organization.phoneNumber || "N/A");
              setEmail(organization.email || "N/A");
              setNotes(organization.notes || "N/A");
              setStatus(organization.status || "N/A");
              setContactName(organization.contactName || "N/A");
              setCreatedById(organization.createdById || "N/A");
              setPassword(organization.password || "N/A");
            } else {
              setError("No organization data found.");
            }
          } catch (error) {
            console.error("Error fetching organization details:", error);
            setError("Failed to fetch organization details.");
          } finally {
            setLoading(false); // Stop loading after the fetch is complete
          }
        };
        fetchorganization();
      }, []); 
      

    const handleAddorganization = () => {
        navigate('/organization/add'); 
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const obj = {
            organizationCode,
            organizationName,
            admissions,
            specialization,
            offers,
            features,
            phoneNumber,
            email,
            notes,
            status,
            contactName,
            createdById,
            password
        };

        try {
            const organizationId = localStorage.getItem('organizationId');
            if (editMode) {
                // eslint-disable-next-line
                const token=localStorage.getItem('Token')
                // eslint-disable-next-line
                const response = await axiosOrganizationInstance.put(`/organization/${organizationId}`, obj, {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
                    }
                });
                alert('organization updated');
                setEditMode(false);
            } else {
                // const token=localStorage.getItem('Token')
                const response = await axiosOrganizationInstance.post('/organization', obj);
                alert('organization added: ' + JSON.stringify(response.data));
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to save organization details.');
        }
    };

    const handleDelete = async () => {
        // const storedId = localStorage.removeItem('organizationId');
        // if (window.confirm("Are you sure you want to delete this organization?")) {
            try {

                const token=localStorage.getItem('Token')
                const organizationId = localStorage.getItem('organizationId');
                await axiosOrganizationInstance.delete(`/organization/${organizationId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
                    },
                });
                alert('organization deleted');
                resetForm();
                navigate("/organization/signin");
            } catch (error) {
                console.error('Error:', error);
                alert('Failed to delete organization.');
            }
        // }
    };

    const resetForm = () => {
        setorganizationCode("");
        setorganizationName("");
        setAdmissions("");
        setSpecialization("");
        setOffers("");
        setFeatures("");
        setPhoneNumber("");
        setEmail("");
        setNotes("");
        setStatus("");
        setContactName("");
        setCreatedById("");
        setPassword("");
        setEditMode(false);
    };

    return (
        <div className="mt-5" style={{display:'flex',flexDirection:'column',backgroundColor:'white',height:'50vh'}}>
            {loading && <p>Loading...</p>}
            {error && <p className="text-danger">{error}</p>}
            {!loading && !error && (
                <>
                    {organizationId === null ? (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <p>No organization linked to this user.</p>
                            <button
                                onClick={handleAddorganization}
                                style={{
                                    padding: "10px 20px",
                                    backgroundColor: "#017EF3",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Add organization
                            </button>
                        </div>
                    ) : (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderBottom: "1px solid #D1D1D6",
                                    marginBottom: "10px",
                                    paddingLeft:'30px'
                                }}
                            >
                                <p style={{ fontSize: "24px", fontWeight: "700",color:'black' }}>{organizationName || "N/A"}</p>
                                {!editMode && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            
                                        }}
                                    >
                                        <Button
                                            variant="outline-dark"
                                            onClick={() => setEditMode(true)}
                                            className="me-2"
                                            style={{
                                                width: "90px",
                                                backgroundColor: "white",
                                                border: "1px solid #017EF3",
                                                color: "#017EF3",
                                            }}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outline-dark"
                                            onClick={() => setShowConfirmation(true)}
                                            style={{
                                                width: "90px",
                                                backgroundColor: "white",
                                                border: "1px solid #017EF3",
                                                color: "#017EF3",
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                )}
                            </div>
    
                            {editMode ? (
                                <div style={{marginLeft:'30px'}}>
                                    <Form onSubmit={handleSubmit} >
                                    <Row style={{ marginBottom: "10px" }}>
                                    <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        organization Name
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    value={organizationName}
                                                    onChange={(e) => setorganizationName(e.target.value)}
                                                    placeholder="Enter organization name"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Registration Number
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    value={organizationCode}
                                                    onChange={(e) => setorganizationCode(e.target.value)}
                                                    placeholder="Enter registration code"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Contact Number
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                    placeholder="Enter contact number"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginBottom: "10px" }}>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Contact Email
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    type="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Enter contact email"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Admissions
                                                    </Form.Label>
                                                </div>
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={admissions === "open"}
                                                    onChange={(e) => setAdmissions(e.target.checked ? "open" : "closed")}
                                                    placeholder="Enter Open or Closed"
                                                    className='custom-checkbox'
                                                />
                                            </Form.Group>
                                        </Col>


                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Specialization
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    value={specialization}
                                                    onChange={(e) => setSpecialization(e.target.value)}
                                                    placeholder="Enter School Specialization"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Notes
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={notes}
                                                    onChange={(e) => setNotes(e.target.value)}
                                                    placeholder="Enter notes"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Offers
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={offers}
                                                    onChange={(e) => setOffers(e.target.value)}
                                                    placeholder="Enter Offers"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <Form.Label
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "700",
                                                            lineHeight: "20px",
                                                            color: "#323E4F",
                                                        }}
                                                    >
                                                        Features
                                                    </Form.Label>
                                                </div>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={features}
                                                    onChange={(e) => setFeatures(e.target.value)}
                                                    placeholder="Enter notes"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "20px",
                                                        color: "#697483",
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Button
                                            variant="outline-dark"
                                            type="submit"
                                            style={{
                                                width: "90px",
                                                backgroundColor: "white",
                                                border: "1px solid #017EF3",
                                                color: "#017EF3",
                                            }}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="outline-dark"
                                            onClick={() => setEditMode(false)}
                                            className="ms-2"
                                            style={{
                                                width: "90px",
                                                backgroundColor: "white",
                                                border: "1px solid #017EF3",
                                                color: "#017EF3",
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Form>
                                    </div>
                                
                            ) : (
                                <div className="row org-details">
                                {/* First Row */}
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Registration Number:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {organizationCode}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Contact Number:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {phoneNumber}
                                        </span>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Email:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {email}
                                        </span>
                                    </div>
                                </div>
                            
                                {/* Second Row */}
                                <div className="w-100 mt-3"></div> {/* Break to next row */}
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Admissions:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {admissions}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Specialization:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {specialization}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Notes:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {notes}
                                        </span>
                                    </div>
                                </div>
                            
                                {/* Third Row */}
                                <div className="w-100 mt-3"></div> {/* Break to next row */}
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Offers:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {offers}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#445164" }}>
                                            Features:{" "}
                                        </span>
                                        <span style={{ fontSize: "14px", color: "#1B2533" }}>
                                            {features}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            )}
                        </>
                    )}
                </>
            )}
    
            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this organization?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-dark"
                        onClick={() => setShowConfirmation(false)}
                        style={{
                            width: "90px",
                            backgroundColor: "white",
                            border: "1px solid #017EF3",
                            color: "#017EF3",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="outline-dark"
                        onClick={handleDelete}
                        style={{
                            width: "90px",
                            backgroundColor: "white",
                            border: "1px solid #017EF3",
                            color: "#017EF3",
                        }}
                    >
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}    

export default OrganizationList;
